// HACK: does nothing, because `toPromise` now lives on the `Observable` itself.
// leaving this module here to prevent breakage.
//# sourceMappingURL=toPromise.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/operator/toPromise.js
// module id = ./node_modules/rxjs/_esm5/add/operator/toPromise.js
// module chunks = vendor